import React from "react";
import { IoMdArrowDropleft, IoMdArrowDropright } from "react-icons/io";
import { useTableColumns } from './useTableColumns.tsx';

const TableHeader = ({ weekDays, formatDay, filters, currentColumnIndex, setCurrentColumnIndex }) => {
    const { visibleColumns, isVisible } = useTableColumns(filters, currentColumnIndex);

    const days = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'];

    const handlePrevColumn = () => {
        setCurrentColumnIndex((i: number) =>
            (i - 1 + visibleColumns.length) % visibleColumns.length
        );
    };

    const handleNextColumn = () => {
        setCurrentColumnIndex((i: number) =>
            (i + 1) % visibleColumns.length
        );
    };

    const metricHeader = (key: string, label: React.ReactNode) => (
        <th key={key} className={`col-${key} weekly-metric-cell fixed-header`}>
            <div className="header-flex">
                <IoMdArrowDropleft className="icon-ocult d-lg-none" style={{ cursor: 'pointer' }} onClick={handlePrevColumn} />
                <span style={{ fontSize: '14px' }}>{label}</span>
                <IoMdArrowDropright className="icon-ocult d-lg-none" style={{ cursor: 'pointer' }} onClick={handleNextColumn} />
            </div>
        </th>
    );

    return (
        <thead className='header-customer'>
            <tr>
                <th className='text-left-important weekly-customer-cell'>
                    Customer
                </th>
                {filters?.password &&
                    <th className='none'>
                        Password
                    </th>}
                {filters?.dailyWinLoss && weekDays.map((date: any, index: any) => {
                    const dayShort = days[index];
                    if (!isVisible(dayShort)) return null;

                    return metricHeader(
                        dayShort,
                        `${dayShort.charAt(0).toUpperCase() + dayShort.slice(1)} (${formatDay(date)})`
                    );
                })}

                {isVisible('week') && metricHeader('week', 'Week')}

                {filters?.pendingBalance && isVisible('pending') && metricHeader('pending', 'Pending')}

                {filters?.depositsWithdrawals && isVisible('depositsWithdrawal') && metricHeader('depositsWithdrawal', '+Dep/-Wd')}

                {filters?.endOfWeekBalance && (
                    <th className="weekly-balance-cell">
                        Balance
                    </th>)}
                {filters?.lastLogin &&
                    <th className="none">
                        Last Login
                    </th>}
                {filters?.lastWager &&
                    <th className="none">
                        Last Wager
                    </th>}
            </tr>
        </thead>
    );
};

export default TableHeader;
